import { convertToUpperSnakeCase } from './../../GetLeads/LeadsSearch/LeadsSearchFiltersMenu/helpers';
import {
  MyLeadsSearchQuery,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';
import { useEffect } from 'react';
import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { selectAudiences } from '@mm/state/selectors/messengerAdSelectors';
import { prepareEsFiltersStructure } from '../MyLeadsFiltersPanel/helpers';
import { useModalActions } from '@mm/state/modules/modalsState/actions';

export type AudiencePresetType = {
  key: string;
  keys: string[];
  name: string;
  searchQuery: MyLeadsSearchQuery;
  color?: string;
  customOnClick?: () => void;
};

export const useSuggestedAudiencesPresets = () => {
  const botId = useSelector(activeChatbotIdSelector);
  const audiences = useSelector(selectAudiences);
  const convertedLeadsAudience = audiences.find(
    a => a.type === 'converted_leads',
  );

  const { retrieveAll } = useAudiencesCRUDActions();
  const { openConversionURLModal } = useModalActions();

  const convertedLeadsOnClick = () => {
    openConversionURLModal({ audience: convertedLeadsAudience });
  };

  const retrieveConvertedLeadsAudiences = async () => {
    await retrieveAll(botId, 1, 25, undefined, true, {
      skipBusy: true,
      type: 'converted_leads',
    });
  };

  useEffect(() => {
    retrieveConvertedLeadsAudiences();
  }, []);

  const presets: AudiencePresetType[] = [
    {
      key: 'returningVisitors',
      keys: ['web_sessions_count'],
      name: 'Returning Visitors',
      searchQuery: {
        query: {
          attributes: {
            web_sessions_count: [{ gt: '2' }],
          },
        },
      },
    },
    {
      key: 'engagedUsers',
      keys: ['num_of_clicks', 'web_page_views'],
      name: 'Highest Engaged Users',
      searchQuery: {
        query: {
          attributes: {
            web_page_views: [{ gt: '2' }],
            num_of_clicks: [{ gt: '3' }],
          },
        },
      },
    },
    {
      key: 'klaviyoPurchase',
      keys: ['klaviyo_purchased'],
      name: 'Purchased via Klaviyo',
      searchQuery: {
        query: {
          attributes: {
            klaviyo_purchased: [true],
          },
        },
      },
    },
    {
      key: 'convertedLeads',
      keys: [SubsectionKeys.urlsVisited],
      name: 'Converted Leads',
      searchQuery: {
        query: convertedLeadsAudience
          ? prepareEsFiltersStructure(convertedLeadsAudience.esFilters)
          : {
              wildcardAttributes: {
                [SubsectionKeys.urlsVisited]: ['checkout', 'cart'],
              },
            },
      },
      color: convertedLeadsAudience ? 'geekblue' : 'green',
      customOnClick: !convertedLeadsAudience
        ? convertedLeadsOnClick
        : undefined,
    },
    {
      key: 'cartPage',
      keys: [SubsectionKeys.urlsVisited],
      name: 'Landed on Cart page',
      searchQuery: {
        query: {
          wildcardAttributes: { [SubsectionKeys.urlsVisited]: ['cart'] },
        },
      },
    },
  ];

  return { presets };
};
